export const TEAMINBOX_NAME = 'Inbox'
export const TEAMINBOX_NAME_PLURAL = 'Inboxes'
export const TEAMINBOX_PATH_NAME = 'team-inboxes'
export const PERSONAL_INBOX_NAME = 'Personal Inbox'
export const CONNECTED_INBOX_NAME = 'Connected Inbox'

